export class Difficulties {
    static moduleName = 'difficulties';
    static moduleEntityName = 'difficultiesEntity';
    static listTitle = 'Справочник проблем';
    static createTitle = 'Добавление новой проблемы';
    static apiPrefix = 'difficulties';
}